import { render, staticRenderFns } from "./GeneralExpansionPanel.vue?vue&type=template&id=71c013ba&scoped=true"
import script from "./GeneralExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./GeneralExpansionPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c013ba",
  null
  
)

export default component.exports